import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const SvgIconTagCar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={18} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M15.625 13.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.625 11.625h-2.25"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M5.125 13.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.125 11.625h-7.5M2.125 11.625V9c0-.621.504-1.125 1.125-1.125h1.125L5.668 5.29a.75.75 0 0 1 .67-.415h6.199a.75.75 0 0 1 .67.415L14.5 7.875h3c.621 0 1.125.504 1.125 1.125v1.875a.75.75 0 0 1-.75.75h-.75M14.5 7.875H4.375M9.25 4.875v3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTagCar;
